const MAX_SPEED_FILTER_KMH = 200;
const MAX_SPEED_FILTER_MPH = 75;

export const MAX_SPEED_FILTER = {
  KMH: MAX_SPEED_FILTER_KMH,
  MPH: MAX_SPEED_FILTER_MPH,
};
